<template>
  <div class="login">
    <div class="login-title">
      <img src="@/assets/images/logintitle.png" alt="" />
    </div>

    <div class="login-form">
      <div class="login-fotm-title">系统登录</div>
      <div class="accountLogin">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
        >
          <el-form-item prop="username">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-zhanghao1"></i> 账号：
              </div>
              <el-input
                v-model="ruleForm.username"
                placeholder="请输入账号"
                type="text"
                class="input"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-zhanghaoanquan"></i> 密码：
              </div>
              <el-input
                v-model="ruleForm.password"
                placeholder="请输入密码"
                :type="!showPass ? 'password' : 'text'"
                class="input"
              >
              </el-input>
              <i class="iconfont" :class="!showPass ? 'icon-mimabukejian' : 'icon-mimakejian'" @click="showPass = !showPass"></i>
            </div>
          </el-form-item>
          <el-form-item prop="code">
            <div class="inputBox">
              <div class="inputTitle">
                <i class="iconfont icon-yanzhengma1"></i> 验证码：
              </div>
              <el-input
                v-model="ruleForm.code"
                placeholder="请输入验证码(不区分大小写)"
                type="text"
                class="input"
              >
              </el-input>
              <div class="yzmimg">
                <img :src="codeSrc" alt="" />
              </div>
              <span @click="getCode()">换一个</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-btn">
        <div class="btn" @click="login('ruleForm')">立即登录</div>
      </div>
      <!--      <div class="login-tex">-->
      <!--        <span @click="to('/orgregister')">没有账号？立即注册 <i class="iconfont icon-jiantouyou"></i></span>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { adminLogin, verify, getAdminDetail } from "@/api/admin";

export default {
  name: "login",
  data() {
    return {
      codeSrc: "",
      showPass: false,
      key: "",
      ruleForm: {
        username: "",
        password: "",
        code: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码格式为6-20位", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  components: {},
  computed: {
    // phone() {
    //   return this.$store.state.phone
    // },
  },
  mounted() {},
  created() {
    this.getCode();
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.passLogin();
        } else {
          this.$message.error("请检查是否填写完整");
          return false;
        }
      });
    },

    // 获取验证码
    async getCode() {
      let _res = await verify();
      if (_res.code === 200) {
        this.codeSrc = _res.data.captcha;
        this.key = _res.data.key;
      } else {
        this.$message.error(_res.message);
      }
    },

    // 登录
    async passLogin() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let _res = await adminLogin(
        this.ruleForm.username,
        this.ruleForm.password,
        this.ruleForm.code,
        this.key
      );
      if (_res.code === 200) {
        loading.close();
        this.$store.state.admintoken = _res.data.token;
        await window.localStorage.setItem(
          "admintoken",
          JSON.stringify(_res.data.token)
        );
        this.getUserInfo();
      } else {
        loading.close();
        this.$message.error(_res.message);
      }
    },

    async getUserInfo() {
      let _data = await getAdminDetail();
      if (_data.code === 200) {
        this.$store.state.adminuser = _data.data;
        await window.localStorage.setItem(
          "adminuser",
          JSON.stringify(_data.data)
        );
        if (_data.data.role_id === 2) {
          this.$router.replace("/adminhome/cdeclarelist");
        } else {
            if (_data.data.city_id > 0) {
                this.$router.replace("/adminhome/declarelist");
            } else {
                this.$router.replace("/adminhome/index");
            }
        }
      }
    },

    // 跳转
    to(path) {
      this.$router.replace(path);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-input__inner {
    border: none;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }
}
.login {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/loginbgc.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .login-form {
    width: 800px;
    height: 510px;
    background-color: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 20px 24px 0px rgba(3, 37, 143, 0.7);
    border-radius: 20px;
    position: relative;
    margin: 0 auto;
    margin-top: 60px;
    padding-top: 50px;
    .login-tex {
      width: 100%;
      padding-top: 20px;
      padding-right: 40px;
      display: flex;
      justify-content: flex-end;
      span {
        font-size: 14px;
        color: #064fb5;
        cursor: pointer;
        i {
          font-size: 16px;
          color: #064fb5;
          font-weight: bold;
        }
      }
    }

    .form-btn {
      width: 100%;
      display: flex;
      justify-content: center;
      .btn {
        width: 264px;
        height: 58px;
        background-color: #064fb5;
        border-radius: 29px;
        text-align: center;
        line-height: 58px;
        font-size: 18px;
        letter-spacing: 2px;
        color: #ffffff;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .accountLogin {
      width: 100%;
      padding: 50px 90px;
      padding-bottom: 25px;

      .inputBox {
        width: 100%;
        height: 54px;
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 25px;
        i {
          font-size: 18px;
          color: #999999;
          cursor: pointer;
        }
        span {
          font-size: 14px;
          color: #064fb5;
          cursor: pointer;
          margin-left: 20px;
        }

        .yzmimg {
          width: 92px;
          height: 40px;
          margin-left: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .inputTitle {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          color: #333333;
          i {
            font-size: 20px;
            color: #ccd9ec;
            margin-right: 10px;
          }
        }

        .input {
          flex: 1;
        }
      }
    }

    .login-fotm-title {
      width: 327px;
      height: 54px;
      background: url("../../assets/images/form-title.png") no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 54px;
      font-size: 24px;
      letter-spacing: 2px;
      color: #ffffff;
      position: absolute;
      top: -4px;
      left: 50%;
      margin-left: -163px;
    }
  }

  .login-title {
    width: 100%;

    img {
      width: 749px;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
